// extracted by mini-css-extract-plugin
export default {"endCourseText":"BtnShop_endCourseText__nJ5QY","shopBtn":"BtnShop_shopBtn__lmyit","specificProductPrice":"BtnShop_specificProductPrice__lUbau"};